// Axios
import axios from 'axios';

// Endpoints
import { ENDPOINTS_POST, ENDPOINTS_PUT, ENDPOINTS_GET, ENDPOINTS_DELETE } from '@/app/apis/auth/_connection/auth-connection-endpoints.js';

// Interceptor
import { authApiInterceptor } from '@/app/apis/auth/_connection/auth-connection-interceptors.js';

// API Instance
export const authPublicInstance = axios.create({
	baseURL: `${process.env.VUE_APP_AUTH_SERVICE_BASE_URL}`,
	headers: {},
	validateStatus: status => {
		return status;
	},
});

// Interceptor
authApiInterceptor(authPublicInstance);

// API Methods
export const AUTH_PUBLIC = {
	post(endpoint, formData) {
		return authPublicInstance.post(endpoint, formData);
	},
	put(endpoint, formData) {
		return authPublicInstance.put(endpoint, formData);
	},
	get(endpoint) {
		return authPublicInstance.get(endpoint);
	},
	delete(endpoint) {
		return authPublicInstance.delete(endpoint);
	}
}

// API Endpoints
export const AUTH_ENDPOINTS_PUBLIC = {
	...ENDPOINTS_POST,
	...ENDPOINTS_PUT,
	...ENDPOINTS_GET,
	...ENDPOINTS_DELETE
}